"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullscreenExit = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var FullscreenExit = function FullscreenExit() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 .667v6C8 7.403 7.403 8 6.667 8h-6A.667.667 0 010 7.333V6c0-.368.298-.667.667-.667h4.666V.667C5.333.298 5.632 0 6 0h1.333C7.702 0 8 .298 8 .667zM23.333 8h-6A1.333 1.333 0 0116 6.667v-6c0-.369.299-.667.667-.667H18c.368 0 .667.298.667.667v4.666h4.666c.369 0 .667.299.667.667v1.333a.667.667 0 01-.667.667zm-4.666 15.333v-4.666h4.666A.667.667 0 0024 18v-1.333a.667.667 0 00-.667-.667h-6c-.736 0-1.333.597-1.333 1.333v6c0 .369.299.667.667.667H18a.667.667 0 00.667-.667zM7.333 24H6a.667.667 0 01-.667-.667v-4.666H.667A.667.667 0 010 18v-1.333C0 16.298.298 16 .667 16h6C7.403 16 8 16.597 8 17.333v6a.667.667 0 01-.667.667z",
    clipRule: "evenodd"
  });
};

exports.FullscreenExit = FullscreenExit;